import React from "react";
import DialogForm from "@/components/modal/DialogForm";
import { useFetchModuleSettingsDataQuery } from "@/api/services/Settings/business/Business";
import { Box, Typography, Divider } from "@mui/material";

const ShiftModal = ({ open, setOpen }) => {
  const { data: rowDetails = {}, isLoading } =
    useFetchModuleSettingsDataQuery("Shift");
  const shiftList = rowDetails?.data || [];

  return (
    <DialogForm
      open={open}
      setOpen={setOpen}
      title="Shift"
      scroll={"paper"}
      width="md"
    >
      <Box sx={{ p: 2 }}>
        {isLoading ? (
          <Typography>Loading...</Typography>
        ) : (
          shiftList.map((shift, index) => (
            <Box key={shift.moduleId || index} sx={{ mb: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                {shift.shiftName}
              </Typography>
              <Typography variant="body2">{shift.description}</Typography>
              <Divider sx={{ my: 1 }} />
            </Box>
          ))
        )}
      </Box>
    </DialogForm>
  );
};

export default ShiftModal;
